// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bci_a bho_wl","LoadingPlaceholder":"bci_b bho_h","loading-placeholder":"bci_c"};